export default __webpack_public_path__ + "static/media/25t.0b058ee7.jpg";